module.exports = __webpack_public_path__ + "static/img/Cody-Angove.d0d975b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cody-Angove.jpg
// module id = lqRT
// module chunks = 0